import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Check } from 'assets/svg/icon-close.svg'

function IconClose(props: IconProps): JSX.Element {
  const title = 'icon-close'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Check {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconClose
